<template>
  <div class="vehicles">
    <v-container class="d-flex justify-center">
      <template>
        <v-card class="ma-2 justify-center">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Οχήματα</h1>
            <v-btn @click="refreshData" icon><v-icon>mdi-refresh</v-icon></v-btn>
            <v-spacer/>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="showHeaders" :items="vehicles"
          dense
          :search="search" loading: false item-key="regnumber" class="elevation-1"
          :items-per-page=15
          :height="$vuetify.breakpoint.height*0.6"
          :loading="loading" loading-text="Loading... Please wait"
          @click:row="clickrow" >
          <template v-slot:top>
          <v-toolbar
            flat
          >
          <v-spacer></v-spacer>
               <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Νεo Οχημα
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Πληροφορίες Oχήματος</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="veh">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="Αριθμός Κυκλοφορίας*"
                  :rules="[rules.required]"
                  v-model="newVehicle.PlateNumber"
                  required
                  @input="newVehicle.PlateNumber = newVehicle.PlateNumber.toUpperCase()"
                  class="upper"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="Αρθμός Πλαισίου*"
                  v-model="newVehicle.Vin"
                  hint="Αρ. Πλαισίου 18 χαρακτήρες"
                  :value="newVehicle.Vin.toUpperCase()"
                  @input="newVehicle.Vin = newVehicle.Vin.toUpperCase()"
                  :rules="[rules.vin, rules.required]"
                  required
                  class="upper"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                >
              <v-text-field
                v-model="newVehicle.Year"
                label="Ετος κατασκευής"
                prepend-icon="mdi-calendar"
                :rules="[rules.year]"
              ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-combobox
                  :items="['VOLVO', 'MAN', 'MERCEDES-BENZ', 'DAF', 'SCANIA', 'NISSAN', 'ISUZU', 'IVECO', 'TOYOTA', 'JCB', 'MAZDA', 'DAIMLER CHRYSL', 'RENAULT', 'VOLKSWAGEN', 'FORD', 'ASTRA', 'BOVA', 'DAEWOO', 'HYUNDAI','ISUZU','KIA','MITSUBISHI','NEOPLAN','SETRA','STEYR','TATRA','CITROEN','LAND ROVER', 'JEEP', 'MAZDA',  'SUZUKI','PEUGEOT', 'SAF', 'ROR', 'OTHER']"
                  label="Μάρκα*"
                  v-model="newVehicle.Make"
                ></v-combobox>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  :items="['Truck', 'Van', 'Bus', 'Trailer', 'PickUp', 'Box', 'Refrigerator', 'Tanker', 'Crane','Crane Dump', 'Crane Flatbed', 'Lift', 'Garbage Pickup', 'Dump Truck', 'Flatbed', 'Tow', 'Mixer', 'Boom Pump', 'Car', 'Tractor', 'Forklift']"
                  :prepend-icon="$vehicleBadges[newVehicle.VehType]"
                  label="Τύπος*"
                  v-model="newVehicle.VehType"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
              <v-select
                v-model="newVehicle.AxleConf"
                :items="axleConfs"
                :item-value="value"
                :item-text="axleConfText"
                label="Διαμόρφωση Αξόνων*"
                required
              >
                <template v-slot:item="data">
                  <div>
                    <div style="font-weight: bold;">{{ data.item.config }}</div>
                    <div style="font-size: 0.85em; color: #666;">{{ data.item.desc }}</div>
                  </div>
                </template>
                <template v-slot:selection="data">
                  <div>
                    <div style="font-weight: bold;">{{ data.item.config }}</div>
                    <div style="font-size: 0.85em; color: #666;">{{ data.item.desc }}</div>
                  </div>
                </template>
              </v-select>
            </v-col>
                        
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  :items="customers"
                  label="Πελάτης"
                  item-text="Name"
                  item-value="Cid"
                  v-model="newVehicle.OwnerId"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
          </v-form>
          <div v-if="newVehicle.AxleConf !== null" style="text-align: center; margin-top: 16px;">
          <img
            :src="require(`@/assets/axle_configs/axle_conf_${newVehicle.AxleConf}.jpg`)"
            :alt="`Axle configuration ${newVehicle.AxleConf}`"
            style="max-width: 300px; width: 100%; border: 1px solid #eee; border-radius: 8px;"
          />
        </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="saveVehicle"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        </v-toolbar>
          </template>
             <template v-slot:item.Vin="{ item }">
             <span>
             <a target="_blank" :href="'https://gr.e-cat.intercars.eu/el/vehicle/external/'+item.Vin">
             {{item.Vin}}
             </a>
            </span>
          </template>
        
          <template v-slot:item.VehType="{ item }">
            <span v-if="!item.VehType">-</span>
            <span v-else>
             <v-icon>{{$vehicleBadges[item.VehType]}}</v-icon>
             <span v-if="$vuetify.breakpoint.mdAndUp">  {{ item.VehType }}</span>
            </span>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="showHeaders.length">More info about {{ item.Id }}</td>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mr-2"
              icon
              small
              :to="'vehicle/details/' + item.Id"
            >
              <v-icon>mdi-information-variant</v-icon>
            </v-btn>
            <v-btn
              class="mr-2"
              icon
              small
              :to="'repair/edit/' + item.LastRepair"
            >
              <v-icon>mdi-wrench-clock</v-icon>
            </v-btn>
            <new-repair :VehId="item.Id" useIcon="true"/>
          </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="dialog=true">Reset</v-btn>
        </template>
        </v-data-table>
        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
import NewRepair from "../components/NewRepair.vue"

export default {

  components: {
    NewRepair
  },
  computed: {
    showHeaders() {
        if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(["Id","Vin", "Owner.Cid"]).includes(h.value));
        } else {
            return this.headers;
        }
    },
  },
  data() {
    return {
      activePicker: 'YEAR',
      menu: false,
      newVehicle: {
        "PlateNumber": "",
        "Vin": "",
        "Year": "",
        "Make": "",
        "Cid": 0,
        "VehType": "Truck",
        "AxleConf": 0,
      },
      vehicles: [],
      customers: [],
      dialog: false,
      loading: true,
      balance: 0.0,
      search: "",
      rules: {
          required: value => !!value || 'Required.',
          vin: value => value.length == 17 || 'VIN must be 17 characters long',
          year: value => 1960 <= parseInt(value) || 'year',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
      axleConfs: [
        {
          value: 0,
          config: "4x2",
          desc: "2 άξονες, 1 κινητήριος"
        },
        {
          value: 1,
          config: "4x4",
          desc: "2 άξονες, 2 κινητήριοι"
        },
        {
          value: 2,
          config: "6x2",
          desc: "3 άξονες, 1 κινητήριος, 1 Τεμπέλης"
        },
        {
          value: 3,
          config: "6x6",
          desc: "3 άξονες, 3 κινητήριοι"
        },
        {
          value: 4,
          config: "6x2/4",
          desc: "3 άξονες, 2 διευθυντήριοι, 1 κινητήριος"
        },
        {
          value: 5,
          config: "6x2*4",
          desc: "3 άξονες, 1 κινητήριος, 1 διευθυντήριος"
        },
        {
          value: 6,
          config: "6x4",
          desc: "3 άξονες, 2 κινητήριοι"
        },
        {
          value: 7,
          config: "8x2*6",
          desc: "4 άξονες, 2 διευθυντήριοι, 1 κινητήριος, 1 διευθ."
        },
        {
          value: 8,
          config: "8x2",
          desc: "4 άξονες, 2 διευθυντήριοι, 1 κινητήριος, 1 Τεμπέλης"
        },
        {
          value: 9,
          config: "8x4",
          desc: "4 άξονες, 2 κινητήριοι"
        },
        {
          value: 10,
          config: "8x2/4",
          desc: "4 άξονες, 3 κινητήριοι"
        },
        {
          value: 11,
          config: "8x4*4",
          desc: "4 άξονες, 2 κινητήριοι, 1 διευθ/τεμπέλης"
        },
        {
          value: 12,
          config: "8x8",
          desc: "4 άξονες, 4 κινητήριοι"
        },
        {
          value: 13,
          config: "6x0",
          desc: "3 άξονες, 0 κινητήριοι"
        }
      ],  
      headers: [
        {
          text: "Α/A",
          align: "start",
          //sortable: false,
          value: "Id",
          width: "5%",
        },
        {
          text: "Αρ. Κυκλοφορίας",
          align: "start",
          //sortable: false,
          value: "PlateNumber",
          width: "10%",
        },
        { text: "VIN", value: "Vin" },
        { text: "Έτος", value: "Year" },
        { text: "Μάρκα", value: "Make" },
        { text: "Τύπος", value: "VehType"},
        { text: "Πελάτης", value: "Owner.Name" },
        { text: "Κωδ. Πελάτη", value: "Owner.Cid" },
        { text: "Actions", value: "actions", width: "15%", sortable: false },
        //{ text: '', value: 'data-table-expand' },
      ],
    };
  },
  async created() {
    // GET request using fetch with async/await
    try {
      await this.fetchVehicles();
      this.loading = false;
      const resp = await this.$api.get("/customers");
      const respb = await this.$api.get("/customers", {params: {'non-billing': true}});
       // console.log(resp);
      this.customers = resp.data.concat(respb.data);
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    clickrow(item, _) {
      //this.$router.push('distributor/'+item.distributor_id)
    },
    async refreshData () {
      this.loading = true;
      const response = await this.$api.get("/repairs/vehicles", { clearCache: true });
      this.vehicles = response.data;
      this.loading = false;
    },
    async fetchVehicles() {
      const response = await this.$api.get("/repairs/vehicles");
      this.vehicles = response.data;
    },
    async saveVehicle () {
      console.log(this.newVehicle);
      if (this.$refs.veh.validate()) {
        const resp = await this.$api.post("/repairs/vehicles", this.newVehicle );
        if (resp.status == 201) {
           await this.fetchVehicles();
        } else
        {
          alert(resp.data.detail);
        }

        this.dialog = false;
      }
    },
    sortBy(prop) {
      this.vehicles.sort((a, b) => (a[prop] < b[prop] ? -1 : 1));
    },
    getColor(status) {
      if (status === "complete") return "green";
      else if (status === "overdue") return "red";
      else return "";
    },
  },
};
</script>

<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}
.project.ongoing {
  border-left: 4px solid #ffaa2c;
}
.project.overdue {
  border-left: 4px solid #f83e70;
}
.v-chip.complete {
  background: #3cd1c2;
}
.v-chip.ongoing {
  background: #ffaa2c;
}
.v-chip.overdue {
  background: #f83e70;
}

.toupper input {
  text-transform: uppercase;
}
</style>
